export enum P2PProviderType {
  Airpay = 'airpay',
  Aggregato = 'aggregato',
  Ampay = 'ampay',
  Argos = 'argos',
  BBRPay = 'bbrpay',
  BeePay = 'beepay',
  BillionPay = 'billionpay',
  BitWire = 'bitwire',
  BNPay = 'bnpay',
  Bova = 'bova',
  BovaMini = 'bova_mini',
  Bridgepay = 'bridgepay',
  Cactus = 'cactus',
  Decard = 'decard',
  EHotPay = 'ehotpay',
  EpayBrl = 'epay-brl',
  Expay = 'expay',
  Exwave = 'exwave',
  FastPay = 'fastpay',
  FlowPay = 'flowpay',
  Fintrix = 'fintrix',
  Garex = 'garex',
  Flackopay = 'flackopay',
  Forta = 'forta',
  Gotham = 'gotham',
  IDMPay = 'idm_pay',
  Incas = 'incas',
  InternalLike = 'internal_like',
  JustMoney = 'just_money',
  Kingsman = 'kingsman',
  Kvell = 'kvell',
  LazyTrade = 'lazytrade',
  ManyPay = 'manypay',
  Mapsign = 'mapsign',
  Mercurio = 'mercurio',
  MoneyHub = 'moneyhub',
  Montra = 'montra',
  Namba = 'namba',
  NoName = 'no_name',
  OnlyOnePays = 'only_one_pays',
  P2PTrade = 'p2ptrade',
  Panda = 'panda',
  Paylord = 'paylord',
  Piqpay = 'piqpay',
  PayCrown = 'paycrown',
  Paycraft = 'paycraft',
  PaycraftElqr = 'paycraft-elqr',
  PaycraftV1_1 = 'paycraft-v1-1',
  Payfinity = 'payfinity',
  PayMatrix = 'paymatrix',
  PayPlace = 'payplace',
  Payscrow = 'payscrow',
  PayscrowMobile = 'payscrow-mobile',
  Payshark = 'payshark',
  PayUp = 'payup',
  Pentax = 'pentax',
  ProFiat = 'profiat',
  Profitable = 'profitable',
  ProfitableLight = 'profitable-light',
  Pulsar = 'pulsar',
  PumP2P = 'pump2p',
  RapidPays = 'rapidpays',
  Reactivepay = 'reactivepay',
  ReactPay = 'reactpay',
  RoyalFinance = 'royal_finance',
  SBPay = 'sbpay',
  SevenXPay = '7xpay',
  SkyPhoenix = 'sky_phoenix',
  Stbl = 'stbl',
  SwipePay = 'swipepay',
  SwipePayV1 = 'swipepay-v1',
  Titanpay = 'titanpay',
  TitanpayAlfa = 'titanpay-alfa',
  TokenRanch = 'token-ranch',
  Transavex = 'transavex',
  TradeSide = 'tradeside',
  Trust2Pay = 'trust2pay',
  TrustCloud = 'trustcloud',
  TrustPay = 'trustpay',
  Tenet = 'tenet',
  X2X = 'x2x',
  XPayments = 'xpayments',
  WorldPay = 'worldpay',
}
